// home banner Slider
$(document).ready(function(){
    $('.home-slider').slick();
});


// image Slider
$(".slider-img").slick({
 slidesToShow: 2,
 slidesToScroll: 1,
 autoplay: true,
 autoplaySpeed: 2000,
 dots: false, 
 arrows: true,
 infinite: true,
 nextArrow:"<div type='button' class='rev-next slick-arrow'><svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'> <path fill-rule='evenodd' clip-rule='evenodd' d='M20.9425 15.0573C21.1924 15.3074 21.3329 15.6464 21.3329 16C21.3329 16.3535 21.1924 16.6926 20.9425 16.9427L13.3998 24.4853C13.2768 24.6127 13.1297 24.7143 12.967 24.7841C12.8043 24.854 12.6294 24.8908 12.4523 24.8923C12.2753 24.8939 12.0997 24.8601 11.9359 24.7931C11.772 24.7261 11.6231 24.627 11.4979 24.5019C11.3728 24.3767 11.2738 24.2278 11.2067 24.0639C11.1397 23.9001 11.1059 23.7245 11.1075 23.5475C11.109 23.3704 11.1458 23.1955 11.2157 23.0328C11.2855 22.8701 11.3871 22.723 11.5145 22.6L18.1145 16L11.5145 9.4C11.2716 9.14853 11.1372 8.81172 11.1402 8.46213C11.1433 8.11253 11.2835 7.77812 11.5307 7.5309C11.7779 7.28369 12.1123 7.14347 12.4619 7.14043C12.8115 7.13739 13.1483 7.27179 13.3998 7.51466L20.9425 15.0573Z' fill='black'/> </svg></div>",
 prevArrow:"<div type='button' class='rev-prev slick-arrow'><svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'> <path fill-rule='evenodd' clip-rule='evenodd' d='M11.0575 15.0573C10.8076 15.3074 10.6671 15.6464 10.6671 16C10.6671 16.3535 10.8076 16.6926 11.0575 16.9427L18.6002 24.4853C18.7232 24.6127 18.8703 24.7143 19.033 24.7841C19.1957 24.854 19.3706 24.8908 19.5477 24.8923C19.7247 24.8939 19.9003 24.8601 20.0641 24.7931C20.228 24.7261 20.3769 24.627 20.5021 24.5019C20.6272 24.3767 20.7262 24.2278 20.7933 24.0639C20.8603 23.9001 20.8941 23.7245 20.8925 23.5475C20.891 23.3704 20.8542 23.1955 20.7843 23.0328C20.7145 22.8701 20.6129 22.723 20.4855 22.6L13.8855 16L20.4855 9.4C20.7284 9.14853 20.8628 8.81172 20.8598 8.46213C20.8567 8.11253 20.7165 7.77812 20.4693 7.5309C20.2221 7.28369 19.8877 7.14347 19.5381 7.14043C19.1885 7.13739 18.8517 7.27179 18.6002 7.51466L11.0575 15.0573Z' fill='black'/> </svg></div>",
 responsive: [{
 breakpoint: 767,
    settings: {
      slidesToShow: 1
    }
  }]
});


// Collectio List Page Filter
$(document).ready(function(){
  $(".collection_filter_button").click(function(){
    $(".facets__wrapper").toggleClass("show");
  });
});


// Pdp Tab
$('.tabs-stage .tab-content').hide();
$('.tabs-stage .tab-content:first-child').show();
$('.tabs-nav li:first').addClass('tab-active');

$('.tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabs-stage .tab-content').hide();
  $($(this).attr('href')).show();
});


// forgot-password-btn 
$(document).ready(function(){
  $(".forgot-password-btn").click(function(){
    $(".forgot-password").slideDown();
    $(".customer.register").slideUp();
  });
  $(".forgot-password-cancle-btn, .forgot-password .link_close").click(function(){
    $(".forgot-password").slideUp();
  });

  $("#account_register__link").click(function(){
    $(".customer.register").slideDown();
    $(".forgot-password").slideUp();
    $(".login-boxs").slideUp();
  });
  $(".create-account-cancle-btn, .register .link_close").click(function(){
    $(".customer.register").slideUp();
    $(".login-boxs").slideDown();
  });
});


// start address js
$(document).ready(function(){
  $(".add-address .link_add").click(function(){
    $(this).parent().addClass("active");
    $("#AddAddress").slideDown();
  });
  $(".add-address .link_close").click(function(){
    $(this).parent().removeClass("active");
    $("#AddAddress").slideUp();
  });
});


// start address js
$(document).ready(function(){
  var tab_id = $(this).attr('data-tab');
  $(".address-head .link_add").click(function(){
    $(this).parent().parent().parent().addClass("active");
  });
  $(".address-head .link_close").click(function(){
    $(this).parent().parent().parent().removeClass("active");
  });
});



//back to top button

$(document).ready(function() {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('#backToTopBtn').fadeIn();
        } else {
            $('#backToTopBtn').fadeOut();
        }
    });

    $('#backToTopBtn').click(function() {
        $('html, body').animate({
            scrollTop: 0
        }, 800); 
        return false;
    });
});



// Buy button sticky
$(document).ready(function() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 500) {
          $('.buy-buttons-sticky').fadeIn();
      } else {
          $('.buy-buttons-sticky').fadeOut();
      }
  });
});


// pdp page image slider
/*  $('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   fade: true,
   adaptiveHeight: true,
    lazyLoad: 'ondemand',
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: false,
    asNavFor: '.slider-for',
    centerMode: false,
    focusOnSelect: true,
    lazyLoad: 'ondemand',
    adaptiveHeight: true,
     prevArrow: ".thumb-prev",
   	nextArrow: ".thumb-next",
 });
$('a[data-slide]').click(function(e) {
 e.preventDefault();
 var slideno = $(this).data('slide');
 $('.slider-nav').slick('slickGoTo', slideno - 1);
});

 */
// home page featured product section atc.
$(document).ready(function(){
  jQuery.getJSON('/cart.js', function(cart) {
    // console.log(cart.item_count);
    $(".cart-count-bubble span.cart_count").text(cart.item_count);
         $(".drawer__header .cart_count").text(cart.item_count);
  });
  
$('button.btn.btn-cart').on('click',function(e){
   e.preventDefault();
  var main_variant_id = $(this).data("id");
  // console.log("id",main_variant_id);
  let arr = [];
  arr.push({id: main_variant_id, quantity: 1 });   
  let formData = {'items': arr};
  // console.log('formData-',formData);
      fetch('/cart/add.js', {
          body: JSON.stringify(formData),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        }).then((response) => {
          return response.json();
        }).then((res) => {
          /* yay! our products were added - do something here to indicate to the user */

  publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId:main_variant_id });

         setTimeout(function() {
       jQuery.getJSON('/cart.js', function(cart) {
        var cart_total_price = cart.total_price;
         // console.log(cart_total_price);
         var cart_val = $(".totals__total-value").text();
           // console.log(cart_val);
        $("span.icon-text.price").text(cart_val);
         $(".cart-count-bubble span.cart_count").text(cart.item_count);
         $(".drawer__header .cart_count").text(cart.item_count);
        var lenDiv = $(".text-flex.fordesktop.price").length;
        // console.log(lenDiv);
        if(lenDiv > 0)
        {
          $(lenDiv).find(".icon-text.price").html(cart_val);
        }
        else
        {
          var price_header = '<div class="text-flex fordesktop price"><a href="#"><span class="icon-text cart-text">cart</span></a><a href="#"><span class="icon-text price">'+ cart_val +'</span></a></div>';
          $("div#cart-icon-bubble").append(price_header);
        }
       });
    }, 200);
        
      
        $(".drawer__inner-empty").remove();
        // $(".cart-drawer__empty-content").remove();
        var cart_status = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
         if (cart_status && cart_status.classList.contains('is-empty')) cart_status.classList.remove('is-empty');
        var cartDrawerButtonSelector = ".header__icon.header__icon--cart";
            var cartDrawerButton = document.querySelector(cartDrawerButtonSelector);
            setTimeout(function() {
               cartDrawerButton.click();
            }, 1000);
          console.log(res);
        if(res.status && res.status == 422){
          console.log("Inventory Error !");
        }else{
          // location.href = "/cart";
          console.log("Added !")
          }
        }).catch((err) => {
          /* uh oh, we have error. */
          console.error(err)
        });
});
    
    

    });

// setTimeout(function() {
//   function createSlick(){
//     $('product-recommendations .product-grid').slick({
//       slidesToShow: 4,
//       slidesToScroll: 1,
//       lazyLoad: 'ondemand',
//       adaptiveHeight: true,
//       dots: false,
//       nextArrow:"<button type='button' class='rev-prev slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'><rect width='20' height='20' rx='3' fill='#B0AFB0'/><path d='M11.5931 9.83656C11.8023 10.0458 11.8023 10.3855 11.5931 10.5948L8.91511 13.2727C8.7059 13.482 8.36613 13.482 8.15691 13.2727C7.9477 13.0635 7.9477 12.7238 8.15691 12.5145L10.4566 10.2148L8.15859 7.91511C7.94937 7.7059 7.94937 7.36613 8.15859 7.15691C8.3678 6.9477 8.70757 6.9477 8.91679 7.15691L11.5948 9.83489L11.5931 9.83656Z' fill='white'/></svg></button>",
//       prevArrow:"<button type='button' class='rev-next slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'><rect width='20' height='20' rx='3' fill='#B0AFB0'/><path d='M8.15691 9.83656C7.9477 10.0458 7.9477 10.3855 8.15691 10.5948L10.8349 13.2727C11.0441 13.482 11.3839 13.482 11.5931 13.2727C11.8023 13.0635 11.8023 12.7238 11.5931 12.5145L9.29338 10.2148L11.5914 7.91511C11.8006 7.7059 11.8006 7.36613 11.5914 7.15691C11.3822 6.9477 11.0424 6.9477 10.8332 7.15691L8.15524 9.83489L8.15691 9.83656Z' fill='white'/></svg></button>",
//       responsive: [{
//       breakpoint: 767,
//         settings: {
//           slidesToShow: 1,
//           dots: true,
//         }
//       }]
//     });
//     }
//   createSlick();
//   $(window).on( 'resize', createSlick );
// }, 2000); 

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

